import React from "react";
import { TextFieldProps } from "@material-ui/core";
import { FieldErrors } from "react-hook-form";
import Validations from "Modules/Validations";
import TextFieldWrapper from "../TextFieldWrapper/TextFieldWrapper";
import PhoneNumberWrapper from "../PhoneNumerWrapper/PhoneNumberWrapper";
import FormErrorMessage from "../FormErrorMessage/FormErrorMessage";
import { FormField } from "../FormField/FormField";
import { FieldsGroup } from "../FieldsGroup/FieldsGroup";
import { EmailFormField } from "./EmailFormField/EmailFormField";
import { getErrorMessage } from "./utils/getErrorMessage";

type AdditionalTextFieldProps = {
  firstName: TextFieldProps;
  lastName: TextFieldProps;
  email: TextFieldProps;
  phoneNumber: TextFieldProps;
}

type PersonalDetailsFormTextFieldsProps = {
  errors: FieldErrors;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  register: any;
  additionalTextFieldProps?: AdditionalTextFieldProps;
};

export const PersonalDetailsFormTextFields = ({
  errors,
  register,
  additionalTextFieldProps,
}: PersonalDetailsFormTextFieldsProps) => {

  return (
    <FieldsGroup>
      <FormField fieldName="First Name">
        <TextFieldWrapper
          name="firstName"
          inputRef={register({ required: true })}
          {...additionalTextFieldProps?.firstName}
        />
        <FormErrorMessage
          showError={!!errors.firstName}
          labelFor="firstName"
          message="Please enter a first name"
        />
      </FormField>
      <FormField fieldName="Last Name">
        <TextFieldWrapper
          name="lastName"
          inputRef={register({ required: true })}
          {...additionalTextFieldProps?.lastName}
        />
        <FormErrorMessage
          showError={!!errors.lastName}
          labelFor="lastName"
          message="Please enter a last name"
        />
      </FormField>
      <EmailFormField
        register={register}
        errors={errors}
        {...additionalTextFieldProps?.email}
      />
      <FormField fieldName="Phone Number">
        <TextFieldWrapper
          inputRef={register({
            required: true,
            validate: (value: string) => {
              const validationResult = Validations.phoneValidations(value);
              return typeof validationResult === "string"
                ? validationResult
                : true;
            },
          })}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          InputProps={{ inputComponent: PhoneNumberWrapper as any }}
          name="phoneNumber"
          {...additionalTextFieldProps?.phoneNumber}
        />
        <FormErrorMessage
          showError={!!errors.phoneNumber}
          labelFor="phoneNumber"
          message={getErrorMessage(
            "Please enter a phone number",
            "phoneNumber",
            errors
          )}
        />
      </FormField>
    </FieldsGroup>
  );
};
